export const resources: Map<string, string> = new Map();
resources.set('oauth', '/oauth');
resources.set('signup', '/signup');
resources.set('user', '/user');
resources.set('technician', '/technician');
resources.set('token', '/token');
resources.set('authCode', '/auth-code');
resources.set('users', '/users');
resources.set('technicians', '/technicians');
resources.set('userFiles', '/userfiles');
resources.set('site', '/site');
resources.set('sites', '/sites');
resources.set('headquarters', '/headquarters');
resources.set('techCode', '/techcode');
resources.set('onSignup', '/on-signup');
resources.set('device', '/device');
resources.set('devices', '/devices');
resources.set('gateways', '/gateways');
resources.set('subgateways', '/subgateways');
resources.set('automations', '/automations');
resources.set('multiio', '/multiio');
resources.set('commands', '/commands');
resources.set('confirm', '/confirm');
resources.set('share', '/share');
resources.set('transfer', '/transfer');
resources.set('transferSites', '/transfer-sites');
resources.set('password', '/password');
resources.set('reset', '/reset');
resources.set('types', '/types');
resources.set('download', '/download');
resources.set('devicestatus', '/devicestatus');
resources.set('deviceModel', '/device-models');
resources.set('model', '/model');
resources.set('models', '/models');
resources.set('info', '/info');
resources.set('gateState', '/gatestates');
resources.set('gateError', '/gateerrors');
resources.set('configurationStates', '/configurationstates');
resources.set('signalLevel', '/signallevel');
resources.set('features', '/features');
resources.set('inputs', '/inputs');
resources.set('outputs', '/outputs');
resources.set('thermostats', '/thermostats');
resources.set('homeautomations', '/homeautomations');
resources.set('alarmsystems', '/alarmsystems');
resources.set('intercoms', '/intercoms');
resources.set('event', '/events');
resources.set('ticket', '/tickets');
resources.set('support', '/support');
resources.set('close', '/close');
resources.set('assignTechnician', '/assign-technician');
resources.set('unassignTechnician', '/unassign-technician');
resources.set('id', '/id');
resources.set('by', '/by');
resources.set('technicianCode', '/technician-code');
resources.set('sceneries', '/sceneries');
resources.set('scenery', '/scenery');
resources.set('settings', '/settings');
resources.set('step', '/steps');
resources.set('action', '/actions');
resources.set('updateOrder', '/update-order');
resources.set('schedule', '/schedule');
resources.set('schedules', '/schedules');
resources.set('calendars', '/calendars');
resources.set('exceptions', '/exceptions');
resources.set('terminal', '/terminal');
resources.set('remoteClients', '/remoteclients');
resources.set('finalUsers', '/final-users');
resources.set('byDevice', '/by-device');
resources.set('shareDevicePendingInvitations', '/share-device-pending-invitations');
resources.set('customerPendingInvitations', '/customer-pending-invitations');
resources.set('invitation', '/invitation');
resources.set('unassign', '/unassign');
resources.set('delete', '/delete');
resources.set('docs', '/docs');
resources.set('mailDevNotif', '/mail-dev-ntf');
resources.set('errorCodes', '/errorcodes');
resources.set('boardUsers', '/boardusers');
resources.set('boardUsersExports', '/boardusers-exports');
resources.set('import', '/import');
resources.set('check', '/check');
resources.set('groups', '/groups');
resources.set('acquire', '/acquire');
resources.set('synctask', '/synctask');
resources.set('addtask', '/addtask');
resources.set('tasks', '/tasks');
resources.set('abort', '/abort');
resources.set('states', '/states');
resources.set('deviceProfiles', '/deviceprofiles');
resources.set('safetyInputs', '/safetyinputs');
resources.set('customers', '/customers');
resources.set('permission', '/permission');
resources.set('permissions', '/permissions');
resources.set('pin', '/pin');
resources.set('execute', '/execute');
resources.set('installedView', '/installed-view');
resources.set('maneuversNotifyRules', '/maneuvers-notify-rules');
resources.set('maneuversNotifyRulesByDevice', '/maneuvers-notify-rules-by-device');
resources.set('update', '/update');
resources.set('devicesAcl', '/devices-acl');
resources.set('registry', '/registry');
resources.set('email', '/email');
resources.set('alias', '/alias');
resources.set('templates', '/templates');
resources.set('control', '/control');
resources.set('sites-online-device', '/sites-online-device');
resources.set('fepreclogin', '/fepreclogin');
resources.set('sitesExtTechAcl', '/sites-ext-techacl');
resources.set('fereleaseversion', '/fereleaseversion');
resources.set('feprivacyversion', '/feprivacyversion');
resources.set('firmwares', '/firmwares');

// api v1
resources.set('api', '/api');
resources.set('v1', '/v1');
resources.set('insights', '/insights');
resources.set('peopleCheck', '/people-check');
resources.set('searchEmail', '/search-email');
resources.set('notifications', '/notifications');
resources.set('mtma', '/mtma');
resources.set('modules', '/modules');
resources.set('contacts', '/contacts');
resources.set('units', '/units');
resources.set('dtmftones', '/dtmftones');
resources.set('tags', '/tags');
resources.set('keypads', '/keypads');
resources.set('actions', '/actions');
resources.set('config', '/config');
resources.set('writeconfig', '/writeconfig');
resources.set('timeslices', '/timeslices');
resources.set('acrules', '/acrules');
resources.set('titles', '/titles');
resources.set('clone', '/clone');
resources.set('active', '/active');
resources.set('changes', '/changes');
resources.set('help', '/help');
resources.set('helpguest', '/helpguest');
resources.set('helpall', '/helpall');
resources.set('helpsearch', '/helpsearch');
resources.set('section', '/section');
resources.set('sections', '/sections');
resources.set('subsection', '/subsection');
resources.set('subsections', '/subsections');
resources.set('subsectionrows', '/subsectionrows');
resources.set('subsectionrow', '/subsectionrow');
resources.set('datetime', '/datetime');
resources.set('updates', '/updates');
resources.set('accesslog', '/accesslog');
resources.set('data', '/data');
resources.set('setrtc', '/setrtc');
resources.set('discover', '/discover');
resources.set('timers', '/timers');
resources.set('timer', '/timer');
resources.set('specialdays', '/specialdays');
resources.set('connectedautomations', '/connectedautomations');
resources.set('calllog', '/calllog');
resources.set('verify', '/verify');
resources.set('writeparams', '/writeparams');
resources.set('statistics', '/statistics');
resources.set('controlaccess', '/controlaccess');
resources.set('specialplannings', '/specialplannings');
resources.set('weeklyschedules', '/weeklyschedules');
resources.set('export', '/export');
resources.set('finalusers', '/finalusers');
resources.set('list', '/list');
resources.set('acinfo', '/acinfo');
resources.set('sync', '/sync');
resources.set('replace', '/replace');
resources.set('exports', '/exports');
resources.set('releasenotes', '/releasenotes');
resources.set('rating', '/rating');
resources.set('local', '/local');
resources.set('deletetask', '/deletetask');
resources.set('tr', '/tr');
resources.set('expired', '/expired');

// api v2
resources.set('v2', '/v2');
resources.set('specialplanning', '/specialplanning');
resources.set('weeklyschedule', '/weeklyschedule');
resources.set('group', '/group');
resources.set('mfa', '/mfa');

export const utilities: any = {
    randomString: (num: number): string => {
        let result = '';
        for (let i = 0; i < num; i++) {
            result += Math.random().toString(36).substring(2, 3);
        }
        return result;
    }
};
